module.exports = __webpack_public_path__ + "static/Priyansha-Bagaria-847cab118784e5ae1c17ffa8a59d64d0.png";